import React from "react";
import { Controller } from "react-hook-form";
import { ReactComponent as AlertCircleIcon } from "../../../../assets/images/AlertCircleIcon.svg";
import { ReactComponent as IconInputError } from "../../../../assets/images/IconInputError.svg";

import { usePublicConfig } from "../../../../hooks/usePublicConfig";
import { SHOPIFY_ENV } from "../../../../utils";

import { Container, Error, Label, StyledInput, Wrapper } from "./styles";

const ModalInput = ({
  label,
  placeholder,
  type,
  control,
  name,
  disabled,
  error,
  rules,
  ...rest
}) => {
  const { env } = usePublicConfig();
  const isShopify = SHOPIFY_ENV.includes(env?.hostEnv);

  return (
    <Container>
      <Label>{label}</Label>

      <Wrapper>
        <Controller
          control={control}
          name={name}
          rules={rules}
          render={({ field }) => (
            <StyledInput
              {...field}
              {...rest}
              placeholder={placeholder}
              type={type}
              suffix={error && !isShopify ? <IconInputError /> : <span />}
              status={error ? "error" : ""}
              disabled={disabled}
            />
          )}
        />

        {error && (
          <Error>
            {isShopify && <AlertCircleIcon />}
            {error}
          </Error>
        )}
      </Wrapper>
    </Container>
  );
};

export default ModalInput;
